import { render, staticRenderFns } from "./CaretBottom.vue?vue&type=template&id=2b5abbd6"
import script from "./CaretBottom.vue?vue&type=script&lang=js"
export * from "./CaretBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports